import { useState, useEffect, useMemo, useCallback } from 'react'

export const useScrollTrigger = (maxHeight: number) => {
  const [status, setTrigger] = useState<boolean>(true)

  const options = useMemo(
    () => ({
      root: null,
      rootMargin: `${maxHeight}px 0px 0px 0px`,
      threshold: 1
    }),
    [maxHeight]
  )

  const handleChange = useCallback((entries: IntersectionObserverEntry[]) => {
    const { isIntersecting } = entries[0]
    setTrigger(isIntersecting)
  }, [])

  useEffect(() => {
    const observer = new IntersectionObserver(handleChange, options)
    const el = document.querySelector('html')

    if (el) {
      observer.observe(el)
    }
    return () => {
      if (el) {
        observer.unobserve(el)
      }
    }
  }, [handleChange, options])

  return { status }
}
